import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=2fe3dd9b&scoped=true&"
import script from "./CampaignTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=2fe3dd9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3dd9b",
  null
  
)

export default component.exports